import { action, thunk } from 'easy-peasy'

import { FormStatus } from '@types'

import { ContactModel, contactService, Response } from '.'
import { AxiosError } from 'axios'

export const contact: ContactModel = {
  data: {} as Response,
  status: FormStatus.IDLE,
  error: '',

  // Actions
  setStatus: action((state, payload) => {
    state.status = payload
  }),
  setData: action((state, payload) => {
    state.data = payload
  }),
  setError: action((state, payload) => {
    state.error = payload
  }),

  // Thunks
  submit: thunk(async (action, payload) => {
    try {
      action.setStatus(FormStatus.LOADING)
      const res = await contactService.submit(payload)
      action.setStatus(FormStatus.SUCCESS)
      action.setData(res.data)
    } catch (e) {
      if (e instanceof AxiosError) {
        action.setStatus(FormStatus.ERROR)
        action.setError(e?.response?.data?.message || (navigator.onLine ? 'Server Error' : 'Network Error'))
      } else {
        console.log(e)
      }
    } finally {
      setTimeout(() => {
        action.setError('')
        action.setStatus(FormStatus.IDLE)
      }, 10)
    }
  })
}
